var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 81,
    viewBox: "0 0 64 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 49H56V81L32 69.5714L8 81V49Z",
    fill: "#AEB8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#404C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 51C42.4934 51 51 42.4934 51 32C51 21.5066 42.4934 13 32 13C21.5066 13 13 21.5066 13 32C13 42.4934 21.5066 51 32 51Z",
    fill: "#758BFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 8L38.7713 22.6801L54.8254 24.5836L42.9562 35.5599L46.1068 51.4164L32 43.52L17.8932 51.4164L21.0438 35.5599L9.17465 24.5836L25.2287 22.6801L32 8Z",
    fill: "#F1F2F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 81,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2753484355edcc152574b8cd2a6e1c31.svg";
export { ForwardRef as ReactComponent };